import { render, staticRenderFns } from "./AuthorTable.vue?vue&type=template&id=54bfbcfc&scoped=true&"
import script from "./AuthorTable.vue?vue&type=script&lang=js&"
export * from "./AuthorTable.vue?vue&type=script&lang=js&"
import style0 from "./AuthorTable.vue?vue&type=style&index=0&id=54bfbcfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bfbcfc",
  null
  
)

export default component.exports